// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TgrBQO{position:relative}.TgrBQO:hover .Z9TP1l{z-index:1;opacity:1}.Z9TP1l{font-size:12px;position:absolute;opacity:0;z-index:-1;top:100%;left:50%;margin-top:15px;transform:translate(-50%, 0);padding:3px 6px;background:#2e2e2e;color:#fff;transition:0.2s opacity;border:1px solid #4a4a4a;white-space:nowrap}@media (max-width: 549px){.Z9TP1l{margin-top:10px}}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": `TgrBQO`,
	"content": `Z9TP1l`
};
export default ___CSS_LOADER_EXPORT___;
